import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

// import { Logger, LoggerTypes } from '../../../../../utils'
import { PageTitle } from '../../../../components'
import { ProjectCard } from '../../ProjectCard'
import './style.scss'

export const ProjectFavoriteList = ({ favorites }) => {
  const { t } = useTranslation()

  // Logger.trace(LoggerTypes.CONTAINER, 'ProjectFavoriteList.render()', { favorites })

  return (
    <div className="ProjectFavoriteList">
      <PageTitle title={t('Favorite projects')} />
      <div className="container">
        {favorites.length === 0 ? (
          <div>{t('projects.favorite.not_found')}</div>
        ) : (
          favorites.map((project, i) => project && <ProjectCard key={`row-${i}`} currentProject={project} />)
        )}
      </div>
    </div>
  )
}

ProjectFavoriteList.displayName = 'ProjectFavoriteList'

ProjectFavoriteList.propTypes = {
  favorites: PropTypes.array.isRequired
}

ProjectFavoriteList.defaultProps = {
  favorites: []
}
